<h6> Het platform is momenteel niet bereikbaar.</h6>
<div class="[ body-large ]">
  Op
  <a [href]="statusPageUrl" target="_blank" class="[ decoration-underline hover:decoration-none ]">{{
    statusPageUrl
  }}</a>
  vind je meer uitleg over wat er aan de hand is.<br />
  Onze excuses.
</div>
